"use client"

import Image from "next/image"
import Modal from "./Modal"
import SingleCarousel from "./Photos/SingleCarousel"
import RightArrow from "@icons/RightArrow.svg?react"
import { snake } from "@utils/String"
import { useState } from "react"
import { upperFirst } from "lodash"
import Contact from "@forms/Contact"
import Link from "next/link"

export default ({ plan }) => {
    const [modalOpen, setModalOpen] = useState(false)
    const [downloadModalOpen, setDownloadModalOpen] = useState(false)
    const images = [plan.cover, plan.plan]

    const form = {
        default: "Download",
        Download: {
            steps: [
                {
                    header: "",
                    title: "Download Floor Plan",
                    step: "DownloadPlan",
                    submit: "Download",
                },
                {
                    title: "Thanks!",
                    content: {
                        html: `We've sent the floor plan to your email! Click <a class="underline font-semibold" href="${process.env.NEXT_PUBLIC_STATIC_PREFIX}/files/${snake(plan.title)}.pdf" download="${plan.title}.pdf">here</a> to download.`,
                    },
                },
            ],
        },
    }

    const downloadGuide = (data) => {
        fetch("/api/download", {
            method: "POST",
            body: JSON.stringify({
                url: window.location.toString(),
                ...data,
                plan: { ...plan },
            }),
        })
    }

    return (
        <>
            <section
                id={plan.title.toLowerCase().replaceAll(" ", "-")}
                className="section"
            >
                <div className="container max-w-5xl px-10 flex mx-auto pb-10 items-stretch flex-col mb-4">
                    <Link
                        className="text-sticks-and-stones font-bold md:hidden"
                        href="/plans"
                    >
                        &larr; Floorplans
                    </Link>
                    <div className="w-full flex gap-4 flex-col md:flex-row">
                        <div className="md:w-2/3 w-full">
                            <div className="relative w-full h-[50vw] md:h-full">
                                <Image
                                    src={
                                        process.env.NEXT_PUBLIC_STATIC_PREFIX +
                                        plan.cover.url
                                    }
                                    fill
                                    alt={plan.cover.alt}
                                    onClick={() => setModalOpen(true)}
                                    className="object-contain cursor-pointer"
                                />
                            </div>
                        </div>
                        <div className="relative w-full md:w-1/3 mx-auto">
                            <div className="bg-downy w-full aspect-square p-8 pb-12 relative">
                                <p className="text-sable font-bold text-sm">
                                    Plan {plan.id}
                                </p>
                                <p className="font-bold font-gelasio text-arugula text-xl">
                                    {plan.title}
                                </p>
                                <p className="text-sable font-light text-sm italic font-gelasio mb-4">
                                    {plan.footage.toLocaleString()} sqft
                                </p>
                                <p className="text-caviar mb-8">
                                    {plan.description}
                                </p>
                                {plan.amenities &&
                                    Object.keys(plan.amenities).map(
                                        (key, idx) => (
                                            <div
                                                key={`${key}`}
                                                className="flex text-sable my-3 w-full justify-between"
                                            >
                                                <span>{upperFirst(key)}</span>
                                                <span className="font-bold">
                                                    {plan.amenities[key]}
                                                </span>
                                            </div>
                                        ),
                                    )}
                                <div className="absolute bottom-0 translate-y-[50%] left-[50%] -translate-x-[50%]">
                                    <button
                                        type="button"
                                        onClick={() =>
                                            setDownloadModalOpen(true)
                                        }
                                        className="bg-arugula w-fit px-5 py-3 font-bold inline-flex items-center hover:bg-garden-grove transition-colors group mx-auto md:mx-0 whitespace-nowrap cursor-pointer"
                                    >
                                        <RightArrow className="rotate-90 size-5 mr-4 fill-garden-grove group-hover:fill-arugula " />
                                        Download Plan
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container max-w-5xl px-10 flex mx-auto justify-between">
                    <a
                        className="text-sticks-and-stones font-bold hidden md:block"
                        href="/plans"
                    >
                        &larr; Floorplans
                    </a>
                    <a
                        className="text-arugula font-bold"
                        target="_blank"
                        href="https://www.jedwardshomedesigns.com/plans"
                    >
                        Discover more J Edwards' Designs &rarr;
                    </a>
                </div>
            </section>
            <Modal
                open={downloadModalOpen}
                close={() => setDownloadModalOpen(false)}
            >
                <div
                    className="m-auto flex w-full max-w-5xl items-stretch"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="hidden md:block bg-twilight-gray w-1/3 relative">
                        <div className="absolute inset-0">
                            <Image
                                src={
                                    process.env.NEXT_PUBLIC_STATIC_PREFIX +
                                    plan.cover.url
                                }
                                fill
                                alt=""
                                className="object-cover w-full h-full"
                            />
                        </div>
                    </div>

                    <div className="grow w-full md:w-2/3">
                        <Contact
                            forms={form}
                            onSubmit={(data) => {
                                downloadGuide(data)
                            }}
                        />
                    </div>
                </div>
            </Modal>
            <Modal open={modalOpen} close={() => setModalOpen(false)}>
                <SingleCarousel
                    images={images}
                    showGalleryButton={false}
                    fullscreen={true}
                    start={0}
                    close={() => setModalOpen(false)}
                />
            </Modal>
        </>
    )
}
